import React from 'react';
import { Calendar, Filter, DollarSign, Building2 } from 'lucide-react';
import { format } from 'date-fns';

export function EarningsFilters({ filters, onFilterChange, companies }) {
  const handleDateChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const handleSelectChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const quickFilters = [
    { label: 'Today', getValue: () => {
      const today = new Date();
      return {
        startDate: format(today, 'yyyy-MM-dd'),
        endDate: format(today, 'yyyy-MM-dd')
      };
    }},
    { label: 'This Week', getValue: () => {
      const now = new Date();
      const weekStart = new Date(now.setDate(now.getDate() - now.getDay()));
      return {
        startDate: format(weekStart, 'yyyy-MM-dd'),
        endDate: format(new Date(), 'yyyy-MM-dd')
      };
    }},
    { label: 'This Month', getValue: () => {
      const now = new Date();
      const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      return {
        startDate: format(monthStart, 'yyyy-MM-dd'),
        endDate: format(new Date(), 'yyyy-MM-dd')
      };
    }},
    { label: 'Last 30 Days', getValue: () => {
      const now = new Date();
      const thirtyDaysAgo = new Date(now.setDate(now.getDate() - 30));
      return {
        startDate: format(thirtyDaysAgo, 'yyyy-MM-dd'),
        endDate: format(new Date(), 'yyyy-MM-dd')
      };
    }}
  ];

  return (
    <div className="bg-surface p-6 rounded-xl border border-border space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold text-text-primary">Filters</h3>
      </div>
      {/* Quick Filters */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {quickFilters?.map((quick) => (
          <button
            key={quick?.label}
            onClick={() => {
              const dates = quick?.getValue();
              onFilterChange({ ...filters, ...dates });
            }}
            className="px-4 py-2 bg-surface-light rounded-lg text-sm text-text-primary hover:bg-primary/10 hover:text-primary transition-colors"
          >
            {quick?.label}
          </button>
        ))}
      </div>
      {/* Date Range */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="flex items-center gap-2 text-sm text-text-secondary mb-2">
            <Calendar className="w-4 h-4" />
            Start Date
          </label>
          <input
            type="date"
            value={filters?.startDate || ''}
            onChange={(e) => handleDateChange('startDate', e?.target?.value)}
            className="w-full px-4 py-2 bg-surface-light border border-border rounded-lg text-text-primary focus:outline-none focus:border-primary"
          />
        </div>
        <div>
          <label className="flex items-center gap-2 text-sm text-text-secondary mb-2">
            <Calendar className="w-4 h-4" />
            End Date
          </label>
          <input
            type="date"
            value={filters?.endDate || ''}
            onChange={(e) => handleDateChange('endDate', e?.target?.value)}
            className="w-full px-4 py-2 bg-surface-light border border-border rounded-lg text-text-primary focus:outline-none focus:border-primary"
          />
        </div>
      </div>
      {/* Company and Status Filters */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="flex items-center gap-2 text-sm text-text-secondary mb-2">
            <Building2 className="w-4 h-4" />
            Company
          </label>
          <select
            value={filters?.companyId || ''}
            onChange={(e) => handleSelectChange('companyId', e?.target?.value)}
            className="w-full px-4 py-2 bg-surface-light border border-border rounded-lg text-text-primary focus:outline-none focus:border-primary"
          >
            <option value="">All Companies</option>
            {companies?.map((company) => (
              <option key={company?.id} value={company?.id}>
                {company?.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="flex items-center gap-2 text-sm text-text-secondary mb-2">
            <DollarSign className="w-4 h-4" />
            Payment Type
          </label>
          <select
            value={filters?.paymentType || 'all'}
            onChange={(e) => handleSelectChange('paymentType', e?.target?.value)}
            className="w-full px-4 py-2 bg-surface-light border border-border rounded-lg text-text-primary focus:outline-none focus:border-primary"
          >
            <option value="all">All Types</option>
            <option value="hourly">Hourly</option>
            <option value="fixed">Fixed</option>
          </select>
        </div>

        <div>
          <label className="flex items-center gap-2 text-sm text-text-secondary mb-2">
            <Filter className="w-4 h-4" />
            Status
          </label>
          <select
            value={filters?.status || 'all'}
            onChange={(e) => handleSelectChange('status', e?.target?.value)}
            className="w-full px-4 py-2 bg-surface-light border border-border rounded-lg text-text-primary focus:outline-none focus:border-primary"
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>
      </div>
    </div>
  );
}